module.exports = __webpack_public_path__ + "img/shape-metal_ag-gold@2x.ab0840b6.png";